function getLang() {
  return navigator?.languages?.[0] || navigator.language;
}
export const dateFormatter = new Intl.DateTimeFormat(getLang(), {
  year: 'numeric',
  month: 'long',
  day: 'numeric',
});
